import { html, TemplateResult } from "lit";
import { DisplayRow, JobItem } from "../data/search-data";
import { JobItemEdit } from "./job-edit-modal";
import { newGuid } from "./view-consts";


const $j = $.fn as any;

export class JobView {
    onChanged: () => void;
    jobitems: JobItem[] = [];
    elementId: string;
    dataTable: any;


    constructor(onChanged: () => void) {
        this.onChanged = onChanged;
        this.elementId = 'job-view-' + newGuid();
    }

    setJobItems(values: JobItem[]) {
        this.jobitems = values;
        this.changed();
    }
    clear() {
        this.jobitems = [];
        this.changed();
    }
    changed() {
        this.onChanged();
    }
    template(): TemplateResult {
        return html`
            <div id=${this.elementId}>
                <div class="mb-3">
                    <button @click=${() => this.clear()} class="btn btn-primary">Clear All</button>
                    <button @click=${()=> this.requestCertificate()} class="btn btn-primary">Request Certificate</button>
                </div>
                <table class="data-table table cell-border table-striped" style="width:1008px">
                    <thead>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>`;
    }
    requestCertificate() {
        throw new Error("Method not implemented.");
    }

    afterRender() {
        const jthis = $('#' + this.elementId);
        this.initializeDataTable(jthis);
    }
    private async initializeDataTable(jthis: any): Promise<void> {

        const $dataTable = jthis.find('.data-table') as any;
        const dataTableInitialized = $j.dataTable.isDataTable($dataTable);

        if (!dataTableInitialized) {
            const columns = [
                {
                    title: "Action",
                    width: "120px",
                    data: null,
                    render: function (value) {
                        return `<i class="act-remove text-danger fas fa-minus-square"></i> <i class="act-edit fas fa-edit text-success" aria-hidden="true"></i>`;
                    }
                },
                {
                    title: "Window ID",
                    width: "120px",
                    data: "windowId"
                },
                {
                    title: "Width",
                    width: "120px",
                    data: "width"
                },
                {
                    title: "Height",
                    width: "120px",
                    data: "height"
                },
                {
                    title: "Calculation",
                    width: "120px",
                    data: "calculation"
                },
                {
                    title: "Manufacturer",
                    width: "250px",
                    data: "manufacturer"
                },
                {
                    title: "Frame Description",
                    width: "250px",
                    data: "frameDescription"
                }

            ];
            this.dataTable = $dataTable.DataTable({
                scrollX: true,
                scrollY: '50vh',
                scrollCollapse: true,
                paging: false,
                order: [[0, "asc"]],
                pageLength: 200,
                bLengthChange: false,
                processing: false,
                serverSide: false,
                data: this.gridData(),
                searching: false,
                info: false,
                columns: columns,
                fixedColumns: { left: 1 },
                autoWidth: false
            });
            let _this = this;
            this.dataTable.columns.adjust();
            $dataTable.on('click', 'i', (ev: Event) => {
                if (ev.target !== null) {
                    var data: JobItem = this.dataTable.row(($(ev.target) as any).parents('tr')).data().jobItem;
                    if (data) {
                        //find the correct feature by testing attached classes on the buttons
                        if ((ev.currentTarget as HTMLElement).classList.contains("act-remove")) {
                            this.delJobItem(data);
                        } else if ((ev.currentTarget as HTMLElement).classList.contains("act-edit")) {
                            this.edit(data);
                        }

                    }
                }
            });
        } else {
            this.dataTable = $dataTable.DataTable();
            this.dataTable.columns.adjust();
            this.refreshGridData();
        }
    }
    edit(data: JobItem) {
        new JobItemEdit(data, () => {
            this.refreshGridData();
        }).showModal();
    }

    public delJobItem(row: JobItem) {
        this.jobitems = this.jobitems.filter(x => x === row);
        this.changed();
    }

    addJobItem(row: DisplayRow) {
        this.jobitems = [...this.jobitems, { displayRow: row, width: null, height: null, calculation: null }];
        this.changed();
    }
    hasJobItem(windowId: string): boolean {
        return this.jobitems.some(f => f.displayRow.windowId === windowId);
    }

    private gridData() {
        let data = this.jobitems.map(x => {
            return {
                jobItem: x,
                "windowId": x.displayRow.windowId,
                "manufacturer": x.displayRow.manufacturer,
                "frameDescription": x.displayRow.frameDescription,
                "width": x.width ?? null,
                "height": x.height ?? null,
                "calculation": x.calculation ?? null
            };
        });
        return data;
    }

    private refreshGridData() {
        this.dataTable
            .clear()
            .rows
            .add(this.gridData())
            .draw();
    }
}